import React from "react";
import styled from "styled-components";
import COLORS from "../../../../assets/Colors";
import theme from "../../../../assets/theme";
import { CloseBtn } from "./CaseTeam";

export const BREAKPOINTS = {
  smallMobile: 360, // baseline — supported floor
  mobile: 480, // larger phones
  tablet: 600, // small tablets / large phones landscape
  laptop: 960, // laptops / large tablets
  desktop: 1280, // standard desktop
  wide: 1600, // wide desktop
};

export const media = {
  mobile: `@media (min-width: ${BREAKPOINTS.mobile}px)`,
  tablet: `@media (min-width: ${BREAKPOINTS.tablet}px)`,
  laptop: `@media (min-width: ${BREAKPOINTS.laptop}px)`,
  desktop: `@media (min-width: ${BREAKPOINTS.desktop}px)`,
  wide: `@media (min-width: ${BREAKPOINTS.wide}px)`,
};

const Modal = ({
  open,
  onClose,
  title,
  subtitle,
  children,
  width = 560,
  hideClose = false,
}) => {
  if (!open) return null;
  return (
    <Overlay onClick={hideClose ? undefined : onClose}>
      <Dialog $width={width} onClick={(e) => e.stopPropagation()}>
        {(title || subtitle) && (
          <Header>
            <HeaderText>
              {title && <Title>{title}</Title>}
              {subtitle && <Subtitle>{subtitle}</Subtitle>}
            </HeaderText>
            {!hideClose && (
              <CloseBtn onClick={onClose}>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </CloseBtn>
            )}
          </Header>
        )}
        <Body className="scrollbar">{children}</Body>
      </Dialog>
    </Overlay>
  );
};

export default Modal;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(26, 35, 56, 0.5);
  z-index: 9999;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 0;
  animation: fadeIn 0.18s ease-out;

  ${media.tablet} {
    align-items: center;
    padding: 20px;
  }
`;

export const Dialog = styled.div`
  background: ${COLORS.PRIMARY_WHITE};
  width: 100%;
  max-width: ${({ $width }) => $width}px;
  max-height: 92vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  animation: slideUp 0.3s ease-out;
  border-radius: 12px 12px 0 0;

  ${media.tablet} {
    max-height: 90vh;
    border-radius: 12px;
  }
`;

export const Header = styled.div`
  padding: 18px 24px;
  border-bottom: 1px solid ${COLORS.BORDER_GREY};
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-shrink: 0;
`;

export const HeaderText = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Title = styled.h3`
  font-family: ${theme.fonts.primaryFontBold};
  font-size: 16px;
  font-weight: 700;
  color: ${COLORS.COLOR_DARK};
  margin: 0;
`;

export const Subtitle = styled.div`
  font-family: ${theme.fonts.primaryFontRegular};
  font-size: 12px;
  color: #5c6b7f;
  margin-top: 3px;
`;

export const Body = styled.div`
  overflow-y: auto;
  flex: 1;
  padding: 0 24px 24px;

  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
`;
